import React from "react";
import { ReactComponent as BookIcon } from "../assets/group-123.svg";
import "../main.css";
import { Container, Grid } from "semantic-ui-react";
import UploadSheet from "./UploadSheet";
import UploadHelp from "./UploadHelp";

export default class ExcelPage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Container>
                    <Grid columns={1} centered className="custom-grid">
                        <Grid.Row>
                            <BookIcon />
                        </Grid.Row>
                        <Grid.Row>
                            <h1
                                style={{
                                    fontSize: "44px",
                                    fontFamily: "Modelica",
                                    fontWeight: 800,
                                }}
                            >
                                Ready to run some quick checks?
                            </h1>
                        </Grid.Row>
                        <Grid.Row>
                            <p>
                                We use the data you provide in this form to
                                setup your programme and match your pupils with
                                brilliant tutors.
                            </p>
                        </Grid.Row>
                        <Grid.Row>
                            <UploadSheet
                                setFileUploaded={this.props.setFileUploaded}
                                setSelectedFile={this.props.setSelectedFile}
                                setGroupedResponse={
                                    this.props.setGroupedResponse
                                }
                                setSingleResponse={this.props.setSingleResponse}
                                selectedFile={this.props.selectedFile}
                                groupedResponse={this.props.groupedResponse}
                                singleResponse={this.props.singleResponse}
                            />
                        </Grid.Row>
                        <Grid.Row>
                            <UploadHelp />
                        </Grid.Row>
                    </Grid>
                </Container>
            </>
        );
    }
}
